module.exports = __webpack_public_path__ + "static/media/test21_3.4041da9f.png";